module.exports = __webpack_public_path__ + "static/media/f-li.f461bc50.svg";